
export default {
    state: { items: [] },
    mutations: {
        setDocumentTypes (state, items) {
            state.items = items;
        },
    }
};